module.exports = __webpack_public_path__ + "static/media/lang7.7ba910bc.mp3";